import { useMutation } from '@tanstack/react-query';

import { AttachmentClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const attachmentClient = new AttachmentClient(apiBaseUrl);

function useDeleteAttachment() {
  return useMutation({
    mutationKey: [queryKeys.Attachment.Delete],
    mutationFn: (id: number) => (attachmentClient.deleteAttachment(id)),
  });
}

export default useDeleteAttachment;
